const BarreTop = () => {
    return (
        <div style={{ width: "100%", borderTop: "5px solid #14356a", marginBottom: "20px" }}></div>
    )
}

export default BarreTop;